import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

import {
    Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Button,
    Grid, Paper, Checkbox, Typography
} from '@mui/material';

import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { fetchItemMaterialData } from '../../../Store/PHPSlice/Item';
import { selectItemMaterialData } from '../../Selectors/Master/ItemSelectors';

const QuotPatternViewEntry = () => {

const { Id, itemId } = useParams();
const dispatch = useDispatch();
const componentRef = useRef();

const baseUrl = process.env.REACT_APP_BASE_URL;

const itemMaterialdata = useSelector(selectItemMaterialData);

const [materialList, setMaterialList] = useState([]);
const [selectedMaterials, setSelectedMaterials] = useState([]);

const [formData, setFormData] = useState({
    quotNo: '',
    itemNm: '',
    partyNm: '',
    patterncnt:'',
    jobrate:''
});

const [patternMatch, setPatternMatch] = useState([]);

const [jobrate, setJobrate] = useState({
    ctinex: '',
    ctoutex: '',
    stinex: '',
    stoutex: '',
    kjinex: '',
    kjoutex: '',
    prinex: '',
    proutex: '',
    mtex: '',
    extex: '',
    totex: '',
    cut_to_pack_ex: '',
    stitch_to_pack_ex: '',
    embriadaryex: '',
    printex: '',
    screenex: ''
});



/* FETCH MATERIAL DATA */

useEffect(() => {

    if(itemId){
        dispatch(fetchItemMaterialData(itemId));
    }

}, [itemId, dispatch]);



useEffect(() => {

    if (itemMaterialdata?.data) {
        setMaterialList(itemMaterialdata.data);
    }

}, [itemMaterialdata]);



/* FETCH QUOTATION DATA */

useEffect(() => {

    const fetchData = async () => {

        try {

            const response = await axios.get(
                `${baseUrl}?apicall=getQuotationlist1&qtId=${Id}`
            );

            const result = response.data;

            if (result.data) {

                setFormData({
                    quotNo: result.data.quotNo,
                    itemNm: result.data.itemNm,
                    partyNm: result.data.partyNm,
                    patterncnt:result.data.patterncnt,
                    jobrate:result.data.jobrate
                });

            }

        } catch (error) {

            console.error("Error fetching quotation:", error);

        }

    };

    if(Id){
        fetchData();
        fetchItemJobRate(itemId,Id);
        fetchPatternMatchingReg(itemId,Id);
    }

}, [Id,itemId]);



/* FETCH JOB RATE */

const fetchItemJobRate = async (itemId,Id) => {

    try{

        const result = await axios.get(
            `${baseUrl}?apicall=getJobRatelist&itemId=${itemId}&qtId=${Id}`
        );
       console.log("res=>",result.data);

        const item = result?.data?.data;

        if(item){

            setJobrate(prev => ({
                ...prev,
                cut_in: item.cut_in,
                cut_out: item.cut_out,
                stitch_in: item.stitch_in,
                stitch_out: item.stitch_out,
                kaje_in: item.kaje_in,
                kaje_out: item.kaje_out,
                press_in: item.press_in,
                press_out: item.press_out,
                material: item.material,
                extra: item.extra,
                total: item.total,
                cut_to_pack: item.cut_to_pack,
                stitch_to_pack: item.stitch_to_pack,
                embriadary: item.embriadary,
                screen: item.screen,
                print: item.print,
               
                 ctinex: item.exct || 0,
    ctoutex: 0,
    stinex: item.exstin || 0,
    stoutex: item.exstout || 0,
    kjinex: item.exkjin || 0,
    kjoutex: item.exkjout || 0,
    prinex: item.exprin || 0,
    proutex: item.exprout || 0,
    mtex: item.exmt || 0,
    extex: item.extex || 0,
    totex: item.extot || 0
            }));

        }

    }catch(error){

        console.log(error);

    }

};
/*FETCH Pattern Matching */
const fetchPatternMatchingReg = async (itemId,Id) => {

    try{

        const result = await axios.get(
            `${baseUrl}?apicall=getquotPatternMatchinglist&itemId=${itemId}&qtId=${Id}`
        );
       console.log("res=>",result.data);

        const item = result?.data?.data;

        if(item){

            setJobrate(prev => ({
                ...prev,
                cut_in: item.cut_in,
                cut_out: item.cut_out,
                stitch_in: item.stitch_in,
                stitch_out: item.stitch_out,
                kaje_in: item.kaje_in,
                kaje_out: item.kaje_out,
                press_in: item.press_in,
                press_out: item.press_out,
                material: item.material,
                extra: item.extra,
                total: item.total,
                cut_to_pack: item.cut_to_pack,
                stitch_to_pack: item.stitch_to_pack,
                embriadary: item.embriadary,
                screen: item.screen,
                print: item.print,
               
                 ctinex: item.exct || 0,
    ctoutex: 0,
    stinex: item.exstin || 0,
    stoutex: item.exstout || 0,
    kjinex: item.exkjin || 0,
    kjoutex: item.exkjout || 0,
    prinex: item.exprin || 0,
    proutex: item.exprout || 0,
    mtex: item.exmt || 0,
    extex: item.extex || 0,
    totex: item.extot || 0
            }));

        }

    }catch(error){

        console.log(error);

    }

};



/* JOBRATE CHANGE */

const handleJobrateChange = (e) => {

    const { name, value } = e.target;

    const newValue = Number(value) || 0;

    const updated = {
        ...jobrate,
        [name]: newValue
    };

    const extraTotal =
        Number(updated.ctinex || 0) +
        Number(updated.ctoutex || 0) +
        Number(updated.stinex || 0) +
        Number(updated.stoutex || 0) +
        Number(updated.kjinex || 0) +
        Number(updated.kjoutex || 0) +
        Number(updated.prinex || 0) +
        Number(updated.proutex || 0) +
        Number(updated.extex || 0) +
        Number(updated.mtex || 0);

    const baseTotal = Number(jobrate.total || 0);

    const grandTotal = parseFloat(baseTotal) + parseFloat(extraTotal);

    if (parseFloat(grandTotal) > parseFloat(formData.jobrate)) {

        alert("Total jobrate cannot exceed Qt Jobrate");

        return;
    }

    updated.totex = extraTotal;

    setJobrate(updated);
};



/* SUBMIT */

const handleSubmit = async () => {

    try {

        const payload = {
            quotId: Id,
            item: itemId,

            jobrateArr: {
                cut: jobrate.cut_in,
                stitch_in: jobrate.stitch_in,
                stitch_out: jobrate.stitch_out,
                kaje_in: jobrate.kaje_in,
                kaje_out: jobrate.kaje_out,
                press_in: jobrate.press_in,
                press_out: jobrate.press_out,
                material: jobrate.material,
                extra: jobrate.extra,
                total: jobrate.total,

                stinex: jobrate.stinex,
                stoutex: jobrate.stoutex,
                kjinex: jobrate.kjinex,
                kjoutex: jobrate.kjoutex,
                prinex: jobrate.prinex,
                proutex: jobrate.proutex,
                mtex: jobrate.mtex,
                extex: jobrate.extex,
                totex: jobrate.totex,
            }

        };

        const res = await axios.post(
            `${baseUrl}?apicall=saveQuotationjobrate`,
            payload
        );

        alert(res.data.msg);

    } catch (error) {

        console.error("Error saving jobrate:", error);
        alert("Error saving jobrate");

    }

};


const grandTotal =
    Number(jobrate.total || 0) + Number(jobrate.totex || 0);
return (

<Grid container justifyContent="center">

<Grid item xs={12} md={10}>

<Paper elevation={5} sx={{ p: 3 }}>

<div ref={componentRef}>

<Typography
variant="h5"
align="center"
sx={{
fontWeight: "bold",
mb: 3,
color: "#1976d2"
}}
>

Quotation Job Rate Entry

<hr style={{border:"2px dashed #000"}}/>

</Typography>



{/* QUOTATION DETAILS */}

<Grid container spacing={2} sx={{ mb: 2 }}>

<Grid item xs={12} sm={3}>
<Typography fontWeight="bold">Quotation No :</Typography>
<Typography>{formData.quotNo}</Typography>
</Grid>

<Grid item xs={12} sm={3}>
<Typography fontWeight="bold">Item Name :</Typography>
<Typography>{formData.itemNm}</Typography>
</Grid>

<Grid item xs={12} sm={3}>
<Typography fontWeight="bold">Party Name :</Typography>
<Typography>{formData.partyNm}</Typography>
</Grid>
<Grid item xs={12} sm={3}>
<Typography fontWeight="bold">Qt Jobrate :</Typography>
<Typography>{formData.jobrate}</Typography>
</Grid>

</Grid>



{/* JOB RATE TABLE */}

<h3>Job Rate</h3>

<table border="1" cellPadding="5">

<thead >

<tr>

<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Cutting-In</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Cutting-Out</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Stitching-In</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Stitching-Out</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Kaje-In</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Kaje-Out</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Press-In</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Press-Out</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Extra</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Material</th>
<th style={{backgroundColor:"#e3f2fd", color:"#000"}}>Total</th>

</tr>

</thead>

<tbody>

<tr>

<td>{jobrate?.cut_in}</td>
<td>{jobrate?.cut_out}</td>
<td>{jobrate?.stitch_in}</td>
<td>{jobrate?.stitch_out}</td>
<td>{jobrate?.kaje_in}</td>
<td>{jobrate?.kaje_out}</td>
<td>{jobrate?.press_in}</td>
<td>{jobrate?.press_out}</td>
<td>{jobrate?.extra}</td>
<td>{jobrate?.material}</td>
<td>{jobrate?.total}</td>

</tr>
{formData.patterncnt > 0 && (

<tr>

<td>
<input
type="number"
name="ctinex"
value={jobrate.ctinex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="ctoutex"
value={jobrate.ctoutex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="stinex"
value={jobrate.stinex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="stoutex"
value={jobrate.stoutex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="kjinex"
value={jobrate.kjinex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="kjoutex"
value={jobrate.kjoutex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="prinex"
value={jobrate.prinex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="proutex"
value={jobrate.proutex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="extex"
value={jobrate.extex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>
<input
type="number"
name="mtex"
value={jobrate.mtex}
onChange={handleJobrateChange}
style={{width:"60px"}}
/>
</td>

<td>{jobrate.totex}</td>

</tr>


)}

</tbody>
<tr style={{ background: "#e3f2fd", fontWeight: "bold" }}>
<td colSpan="10" align="right"><b>Job Total</b></td>
<td><b>{grandTotal}</b></td>
</tr>

</table>

</div>



<Grid container spacing={2} sx={{ mt: 3 }} justifyContent="center">

<Grid item>

{formData.patterncnt > 0 && (

<Button
variant="contained"
color="success"
onClick={handleSubmit}
>
Submit
</Button>

)}

</Grid>

</Grid>

</Paper>

</Grid>

</Grid>

);

};

export default QuotPatternViewEntry;